import React from 'react'
import { Row } from 'react-bootstrap'
import { trans } from 'sharedKernel/i18n'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { ROUTES } from 'sharedKernel/constants'

export const LoginButton = (): JSX.Element => {
  const navigate = useNavigate()

  const labels = {
    alreadyHaveAccount: trans('Já tem cadastro?'),
    login: trans('Faça o login.')
  }
  return (
        <Row className='px-2 mt-2'>
            <span className='mb-4 text-center'>
              {labels.alreadyHaveAccount}{' '}
              <span 
                onClick={() => navigate(ROUTES.USER_AUTH.LOGIN)} 
                style={{ 
                  textDecoration: 'underline', 
                  color: '#0066B3',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                {labels.login}
              </span>
            </span>
        </Row>
  )
}
